import Crud from '../views/HistoricoEdicaoNome/Crud'

let routes = {
    path: '/historico-edicao-nome',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/historico-edicao-nome',
            name: 'historico-edicao-nome',
            component: Crud,
            meta: {
                pageTitle: 'Histórico de Alteração de Nome',
                breadcrumb: [
                    {
                        text: 'Histórico de Alteração de Nome',
                        active: true,
                        to: '/historico-edicao-nome',
                    },
                ],
            },
        },
    ]
};


export default routes
